import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';


/***
 * Send email to users
 */
@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor(
    private http: HttpClient
  ) { }

  reSendActivationEmail(userId: number) {
    const activationURL = `${window.location.origin}/auth/set-password`;
    return this.http.post(`${environment.api_url}/Account/resend-email`, {}, {params: {userId, activationURL}});
  }

}
